import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useUILanguage } from '../../Hooks/useLanguagePersistence';

export const useI18nLanguage = () => {
  const [language, setLanguage] = useUILanguage();
  const { i18n } = useTranslation();
  const isChangingRef = useRef(false);
  const latestRequestedRef = useRef(language);

  // Sync i18n when localStorage language changes (one-way sync)
  useEffect(() => {
    if (isChangingRef.current) {
      isChangingRef.current = false;
      return;
    }
    if (language && i18n.language !== language) {
      latestRequestedRef.current = language;
      i18n.changeLanguage(language).catch(() => {
        // Silent fail
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  const changeLanguage = (lng) => {
    if (lng === language && i18n.language === lng) {
      return;
    }
    isChangingRef.current = true;
    latestRequestedRef.current = lng;
    setLanguage(lng);
    // Rapid switch: last selected language always wins; wait for re-apply before clearing flag
    i18n
      .changeLanguage(lng)
      .then(() => {
        if (latestRequestedRef.current !== lng) {
          return i18n.changeLanguage(latestRequestedRef.current);
        }
      })
      .catch(() => {})
      .finally(() => {
        isChangingRef.current = false;
      });
  };

  return {
    language,
    changeLanguage,
    isRTL: language === 'ar' || language === 'he',
  };
};
